import React from 'react';

function HolidayCalendar({ monthIndex, selectedHolidays, onToggleHoliday }) {
  const today = new Date();
  const monthDate = new Date(today.getFullYear(), today.getMonth() + monthIndex, 1);
  const year = monthDate.getFullYear();
  const month = monthDate.getMonth();
  const firstDay = new Date(year, month, 1);
  const startDate = new Date(firstDay);
  startDate.setDate(startDate.getDate() - firstDay.getDay());

  const monthNames = [
    '1月',
    '2月',
    '3月',
    '4月',
    '5月',
    '6月',
    '7月',
    '8月',
    '9月',
    '10月',
    '11月',
    '12月',
  ];
  const weekdays = ['日', '月', '火', '水', '木', '金', '土'];

  const formatDateForHoliday = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const isSameDateForHoliday = (date1, date2) => {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };

  const currentDate = new Date(startDate);
  const days = [];

  for (let i = 0; i < 42; i++) {
    const dateStr = formatDateForHoliday(currentDate);
    const isCurrentMonth = currentDate.getMonth() === month;
    const isSelected = selectedHolidays.has(dateStr);
    const isToday = isSameDateForHoliday(currentDate, new Date());

    days.push({
      date: new Date(currentDate),
      dateStr,
      isCurrentMonth,
      isSelected,
      isToday,
    });

    currentDate.setDate(currentDate.getDate() + 1);
  }

  return (
    <div className="holiday-calendar-month" id={`holidayCalendarMonth${monthIndex + 1}`}>
      <h4>
        {year}年{monthNames[month]}
      </h4>
      <div className="holiday-calendar-grid">
        {weekdays.map((day) => (
          <div key={day} className="holiday-calendar-day-header">
            {day}
          </div>
        ))}
        {days.map((day, idx) => {
          let classes = 'holiday-calendar-day';
          if (!day.isCurrentMonth) {
            classes += ' other-month';
          }
          if (day.isSelected) {
            classes += ' selected';
          }

          return (
            <div
              key={idx}
              className={classes}
              data-date={day.dateStr}
              data-day={day.date.getDay()}
              onClick={() => {
                if (day.isCurrentMonth) {
                  onToggleHoliday(day.dateStr);
                }
              }}
            >
              {day.date.getDate()}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default HolidayCalendar;

